import { deburr } from 'lodash';

export function hasMatch(haystack: string, needle: string): boolean {
	needle = deburr(needle).toLowerCase();
	haystack = deburr(haystack).toLowerCase();

	return haystack.includes(needle);
}
